import React from 'react';
import './Dropdown.scss';

interface OptionsItem {
  id?: any;
  value: number;
  label: string;
}

interface OptionsItems extends Array<OptionsItem> {}

interface Props {
  optionsItems?: OptionsItems;
  valueChanged?: (e: Event) => void;
}

export const Dropdown: React.FC<Props> = ({ optionsItems, valueChanged }) => {
  const handleChanged = (e: any) => {
    if (valueChanged) valueChanged(e);
  };

  return (
    <select onChange={handleChanged}>
      {optionsItems ? (
        optionsItems.map((opt, index) => (
          <option key={opt.id || 'drop-' + index} value={opt.value}>
            {opt.label}
          </option>
        ))
      ) : (
        <option value="0">Default</option>
      )}
    </select>
  );
};
